import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { useAuth } from '../context/AuthContext';
import Sidebar from '../components/Sidebar';
import { DISCIPLINES, projectDisciplines, disciplinePaths } from '../disciplines';
import Footer from '../components/Footer';
import '../App.css';

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const q = query(
          collection(db, 'projects'),
          where('members', 'array-contains', currentUser.uid)
        );
        const snapshot = await getDocs(q);
        const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        const filtered = data.filter(p => p.deleted !== true);
        filtered.sort((a, b) => (a.address || '').localeCompare(b.address || ''));
        setProjects(filtered);
      } catch (err) {
        console.error('Error fetching projects:', err);
      }
      setLoading(false);
    };
    if (currentUser) fetchProjects();
  }, [currentUser]);

  return (
    <div>
      <Sidebar />
      <div style={styles.container}>
        {loading ? (
          <p style={styles.message}>Loading projects...</p>
        ) : projects.length === 0 ? (
          <p style={styles.message}>No projects found. Create your first project.</p>
        ) : (
          <div style={styles.grid}>
            {projects.map((project) => (
              <div
                key={project.id}
                style={styles.card}
                onClick={() => navigate(disciplinePaths(project.id, projectDisciplines(project)[0]).photos)}
                onMouseEnter={e => e.currentTarget.style.boxShadow = '0 4px 16px rgba(100,149,237,0.5)'}
                onMouseLeave={e => e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.12)'}
              >
                <div style={styles.folderIcon}>📁</div>
                <div style={styles.address}>{project.address || 'No address'}</div>
                <div style={styles.county}>{project.county || ''}</div>
                <div style={styles.tags}>
                  {DISCIPLINES.filter(d => projectDisciplines(project).includes(d.key)).map(d => (
                    <span key={d.key} style={styles.tag}>{d.label}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

const styles = {
  tags: { display: 'flex', gap: '0.3rem', justifyContent: 'center', flexWrap: 'wrap', marginTop: '0.4rem' },
  tag:  { fontSize: '0.7rem', fontWeight: '600', color: '#112b49', backgroundColor: 'rgba(100,149,237,0.15)', borderRadius: '10px', padding: '0.1rem 0.5rem' },
  container: {
    marginLeft: '200px',
    padding: '2rem',
    paddingBottom: '4rem',
  },
  message: {
    color: '#112b49',
    fontSize: '1rem',
    marginTop: '2rem',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
    gap: '1.25rem',
  },
  card: {
    backgroundColor: 'rgba(255,255,255,0.92)',
    borderRadius: '8px',
    padding: '1.25rem 1rem',
    boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
    cursor: 'pointer',
    textAlign: 'center',
    transition: 'box-shadow 0.2s ease',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '0.5rem',
  },
  folderIcon: {
    fontSize: '2.5rem',
  },
  address: {
    fontSize: '0.875rem',
    fontWeight: '600',
    color: '#112b49',
    wordBreak: 'break-word',
  },
  county: {
    fontSize: '0.75rem',
    color: '#666',
  },
};

export default Projects;